import {API} from 'aws-amplify';
import _ from 'lodash';
import fp from 'lodash/fp';
import uuidv4 from 'uuid/v4'

const API_NAME = 'megali-logistic'

// API Methods
// Query
const scanUsers = () =>
  get(
    '/admin/logistic',
    'SCAN_USER',
    {}
  );

const scanMeta = () =>
  get(
    '/admin/logistic',
    'SCAN_META',
    {}
  );

const queryMetaById = _id =>
  get(
    '/admin/logistic',
    'QUERY_META_BY_ID',
    {
      _id
    }
  );

const queryDeliveriesByDate = async (startDate, endDate) => {
  const intervals = getTimeIntervals (startDate, endDate)
  const rep = await Promise.all(
    fp.map
      (p => get(
        '/admin/logistic',
        'QUERY_DELIVERIES_BY_DATE',
        {
          startDate: p[0],
          endDate: p[1],
        }
      )
    )
    (intervals)
  );
  return fp.flatten (rep)
  // const syncRep = await get(
  //   '/admin/logistic',
  //   'QUERY_DELIVERIES_BY_DATE',
  //   {
  //     startDate,
  //     endDate,
  //   }
  // );
  // console.log(syncRep)
  // console.log('isEqual', _.isEqual (flattened, syncRep))
  // return syncRep
}

const querySlotByIdAndSK = (_id, SK) =>
  get(
    '/admin/logistic',
    'QUERY_SLOT_BY_ID_AND_SK',
    {
      _id,
      SK
    }
  );

const querySlotsByDate = async (startDate, endDate) => {
  const intervals = getTimeIntervals (startDate, endDate)
  const rep = await Promise.all(
    fp.map
    (p => get(
      '/admin/logistic',
      'QUERY_SLOTS_BY_DATE',
      {
        startDate: p[0],
        endDate: p[1],
      }
    )
    )
    (intervals)
  );
  return fp.flatten (rep)
}

const queryEventsByDate = async (startDate, endDate) => {
  const intervals = getTimeIntervals (startDate, endDate)
  const rep = await Promise.all(
    fp.map
      (p => get(
        '/admin/logistic',
        'QUERY_EVENTS_BY_DATE',
        {
          startDate: p[0],
          endDate: p[1],
        }
      )
    )
    (intervals)
  );
  return fp.flatten (rep)
}
  // get(
  //   '/admin/logistic',
  //   'QUERY_EVENTS_BY_DATE',
  //   {
  //     startDate,
  //     endDate
  //   }
  // );

const queryDeliveriesById = (_id) =>
  get(
    '/admin/logistic',
    'QUERY_DELIVERIES_BY_ID_AND_DATE',
    {
      _id,
    }
  );

const queryEventsByIdAndDate = (_id, startDate, endDate) =>
  get(
    '/admin/logistic',
    'QUERY_EVENTS_BY_ID_AND_DATE',
    {
      _id,
      startDate,
      endDate
    }
  );


// Effect
const createUser = ({name, email, userType}) =>
  post(
    '/admin/logistic',
    'CREATE_USER',
    {
      userName: name,
      email,
      userType
    }
  );

const createMeta = ({_id, slotNumber, finalSlot, paused}) =>
  post(
    '/admin/logistic',
    'CREATE_META',
    {
      _id,
      slotNumber: _.toNumber(slotNumber),
      finalSlot,
      paused
    }
  );

// const createSlot = ({timestamp, status, value, weight, distance}) =>
//   post(
//     '/admin/logistic',
//     'CREATE_SLOT',
//     {
//       timestamp,
//       status,
//       value: parseInt(_.toNumber(value) * 100),
//       weight: parseInt(weight),
//       distance: parseInt(distance)
//     }
//   );
// 
const fixSlotTypes = ({age, value, weight, distance, slotNumber, slotType, ...rest}) => ({
  value: parseInt(_.toNumber(value) * 100),
  weight: parseInt(weight),
  distance: parseInt(distance),
  slotNumber: parseInt(slotNumber),
  age: parseInt(age),
  slotType: _.toLower(slotType),
  ...rest,
});
const createDelivery = ({_id, timestamp, slotGroup, comment}) =>
  post(
    '/admin/logistic',
    'CREATE_DELIVERY',
    {
      _id,
      timestamp,
      slotGroup: _.map(slotGroup, fixSlotTypes),
      comment: comment || '-'
    }
  );

const createEvent = ({_id, SK, timestamp, event, eventType}) =>
  post(
    '/admin/logistic',
    'CREATE_EVENT',
    {
      _id,
      SK,
      timestamp,
      event,
      eventType: eventType || 'user'
    }
  );

const createTransfer = ({_id, SK, vehicleId, timestamp, event, status}) =>
  post(
    '/admin/logistic',
    'CREATE_TRANSFER',
    {
      _id,
      SK,
      timestamp,
      vehicleId,
      event,
      status
    }
  );

const createPausedEvent = () =>
  post(
    '/admin/logistic',
    'CREATE_PAUSED_EVENT',
    {}
  );

const createChooseEvent = () =>
  post(
    '/admin/logistic',
    'CREATE_CHOOSE_EVENT',
    {}
  );

const createUnavailableEvent = ({startDate, endDate, maxEnrolled}) =>
  post(
    '/admin/logistic',
    'CREATE_UNAVAILABLE_EVENT',
    {
      startDate,
      endDate,
      maxEnrolled
    }
  );

const chooseVehicle = ({_id, startDate, endDate, maxEnrolled}) =>
  put(
    '/admin/logistic',
    'CHOOSE_VEHICLE',
    {
      _id,
      startDate,
      endDate,
      maxEnrolled
    }
  );

const updateMeta = ({_id, slotNumber, finalSlot, paused}) =>
  put(
    '/admin/logistic',
    'UPDATE_META',
    {
      _id,
      slotNumber: _.toNumber(slotNumber),
      finalSlot,
      paused
    }
  );

const updateDelivery = ({_id, timestamp, status, slotId}) =>
  put(
    '/admin/logistic',
    'UPDATE_DELIVERY',
    {
      _id,
      timestamp,
      status,
      slotId
    }
  );

const updateDeliveryStatus = ({_id, timestamp, status}) =>
  put(
    '/admin/logistic',
    'UPDATE_DELIVERY_STATUS',
    {
      _id,
      timestamp,
      status
    }
  );

const updateDeliveryVehicle = ({_id, timestamp, vehicleId, status}) =>
  put(
    '/admin/logistic',
    'UPDATE_DELIVERY_VEHICLE',
    {
      _id,
      timestamp,
      vehicleId,
      status
    }
  );

const updateEvent = ({_id, timestamp, event}) =>
  put(
    '/admin/logistic',
    'UPDATE_EVENT',
    {
      _id,
      timestamp,
      event
    }
  );

const updateSlot = (data) => {
  const {
    _id,
    SK,
    value,
    distance,
    weight,
    slotType,
    slotNumber,
    member,
    age,
  } = fixSlotTypes(data)

  return put(
    '/admin/logistic',
    'UPDATE_SLOT',
    {
      _id,
      SK,
      value,
      distance,
      weight,
      slotType,
      slotNumber,
      member,
      age,
    }
  );
};

const deleteUser = ({_id}) =>
  del(
    '/admin/logistic',
    'DELETE_USER',
    {
      _id,
    }
  );

const deleteMeta = ({_id}) =>
  del(
    '/admin/logistic',
    'DELETE_META',
    {
      _id,
    }
  );

const deleteDelivery = ({_id, timestamp}) =>
  del(
    '/admin/logistic',
    'DELETE_DELIVERY',
    {
      _id,
      timestamp
    }
  );

const deleteEvent = ({_id, timestamp}) =>
  del(
    '/admin/logistic',
    'DELETE_EVENT',
    {
      _id,
      timestamp
    }
  );

const deleteSlot = ({_id, SK}) =>
  del(
    '/admin/logistic',
    'DELETE_SLOT',
    {
      _id,
      SK
    }
  );

// Abstract
const get = async (path, action, params, retries=3) => {
  try {
    return await APICall(
      'get',
      path,
      {
        queryStringParameters: {
          type: action,
          uuid: uuidv4(),
          ...params
        }
      }
    );
  } catch (e) {
    if (e.response && e.response.status === 404) return []
    if (retries > 0) return get(path, action, params, --retries)
    alert ('Erro de conexão. Favor, verificar seu serviço de internet.')
    console.error(e)
    return []
  }
};

const post = (path, action, params) =>
  effect('post', path, action, params);

const put = (path, action, params) =>
  effect('put', path, action, params);

const del = (path, action, params) =>
  effect('del', path, action, params);

const effect = (method, path, action, params) =>
  APICall(
    method,
    path,
    {
      body: {
        type: action,
        uuid: uuidv4(),
        mutation: params
      }
    }
  );

const APICall = async (method, path, options) => {
  try {
    const response = await API[method](
      API_NAME,
      encodeURI(path),
      options
    );
    if (process.env.NODE_ENV === 'development')
      logRequest(method, path, options, response);
    return response;
  } catch (e) {
    if (process.env.NODE_ENV === 'development')
      logError(method, path, options, e);
    throw e;
  }
};

const getTimeIntervals = (startDate, endDate) => {
  const _startDate = Number (startDate)
  const _endDate = Number (endDate)
  const dayInterval = 1000*60*60*48
  const interval = _endDate - _startDate
  const mod = interval % dayInterval
  const indexes = _.range(0, Math.floor(interval / dayInterval) + 1)
  const limits = fp.compose
    ([ fp.concat (_startDate - 1)
     , fp.map (fp.compose
        ([ fp.add (_startDate)
         , fp.add (mod)
         , fp.multiply (dayInterval)
        ]))
    ])
    (indexes)
  return fp.compose
  ([ fp.map(fp.map(fp.toString))
   , fp.map (pair => [limits[pair[0]] + 1, limits[pair[1]]])
   , fp.map (idx => [idx, idx + 1])
  ]) (indexes)
}

const logRequest = (method, path, options, response) => {
  const action = options.queryStringParameters?.type || options.body?.type
  console.groupCollapsed(
    `%cREQUEST %c${method} %c${action} %c${path}`,
    defaultDebugStyles.requestRequest,
    defaultDebugStyles.requestMethod,
    defaultDebugStyles.actionName,
    defaultDebugStyles.requestUrl
  );
  console.groupCollapsed(`%cParameters`, defaultDebugStyles.requestOptions)
  console.dir(options);
  console.groupEnd();
  console.groupCollapsed(`%cResponse`, defaultDebugStyles.requestResponse)
  console.dir(response);
  console.groupEnd();
  console.groupEnd();
};

const logError = (method, path, options, error) => {
  const action = options.queryStringParameters?.type || options.body?.type
  console.groupCollapsed(
    `%cREQUEST %c${method} %c${action} %c${path} `,
    defaultDebugStyles.requestError,
    defaultDebugStyles.requestMethod,
    defaultDebugStyles.actionName,
    defaultDebugStyles.requestUrl
  );
  console.groupCollapsed(`%cParameters`, defaultDebugStyles.requestOptions)
  console.dir(options);
  console.groupEnd();
  console.groupCollapsed(`%cError`, defaultDebugStyles.requestError);
  console.dir(error);
  console.trace();
  console.groupEnd();
  console.groupEnd();
};

const defaultDebugStyles = {
  actionSource: 'color: #f0f;',
  actionName: 'color: #970;',
  actionErrorName: 'color: #e33;',
  actionInfo: 'color: #aaa;',

  requestUrl: 'color: #05f; text-decoration: underline;',
  requestMethod: 'color: #09a; font-weight: bold;',
  requestOptions: 'color: #aa0; font-weight: bold;',
  requestRequest: 'color: #0a0; font-weight: bold;',
  requestResponse: 'color: #4af; font-weight: bold;',
  requestError: 'color: #e33; font-weight: bold;'
};

export default {
  chooseVehicle,
  scanMeta,
  scanUsers,
  queryMetaById,
  queryDeliveriesByDate,
  queryEventsByDate,
  querySlotByIdAndSK,
  querySlotsByDate,
  queryDeliveriesById,
  queryEventsByIdAndDate,
  createUser,
  createMeta,
  updateSlot,
  createDelivery,
  createEvent,
  createTransfer,
  createChooseEvent,
  createPausedEvent,
  createUnavailableEvent,
  updateMeta,
  updateDelivery,
  updateDeliveryStatus,
  updateDeliveryVehicle,
  updateEvent,
  deleteUser,
  deleteMeta,
  deleteDelivery,
  deleteEvent,
  deleteSlot,
}

